import { SupercedeDisplayCondition } from "../../constants/enums.js";
import { IPricedProduct } from "@wbmason/cart-service/interfaces/pricedProduct.js";
import { ISupercedeProduct } from "@wbmason/cart-service/interfaces/supercedeProduct.js";
import { IProductImage } from "../../interfaces/IProductImage.js";
import { IProductInfo } from "../../interfaces/IProductInfo.js";
import { IIndicatorIcon } from "../../interfaces/IIndicatorIcon.js";
import { IItemAvailability } from "../../interfaces/IItemAvailability.js";
import { ISupersedeCartItem } from "../../interfaces/ISupersedeCartItem.js";

export function dataTransform(
  supercede: IPricedProduct,
  productImages: IProductImage[]
) {
  const productImage = productImages.filter(
    (image) => image.ecItemRefRecID.toString() === supercede.id
  );

  const description =
    supercede.text.find((item) => item.textType === 0)?.text || "";
  const dataTrans: IProductInfo = {
    itemId: supercede.itemId,
    unitId: supercede.unitId,
    sku: "",
    brandName: supercede.brandName,
    description,
    unitPrice: supercede.sellPrice,
    listPrice: supercede.listPrice,
    imageUrl: productImage.length
      ? `${productImage[0].imagePath}/${productImage[0].imageFileName}`
      : "",
    sellingPoints: [],
    itemIdentifier: {
      id: supercede.itemId,
      unitId: supercede.unitId,
      couponOfferCode: supercede.couponOfferCode,
    },
    priceCode: "",
    limitQty: 0,
    oncePerCustomer: false,
    showBuyRightImage: supercede.showBuyRightImage,
    displayAddNote: false,
    preventPurchase: false,
    relevanceScore: null,
    permitPurchase: true,
    webNonReturnable: false,
    salesPrice: 0,
    salesLineDisc: 0,
    lineLevelCouponSavings: {
      savings: 0,
    },
    attributes: null,
    pricingMethod: "",
    purchaseProcess: 0,
  };
  return dataTrans;
}

export function cartItemTransform(
  supercede: ISupercedeProduct,
  itemIndicators: IIndicatorIcon[],
  availabilityInfo: IItemAvailability,
  productImages: IProductImage[],
  hostUrl: string
) {
  const description =
    supercede.sourceProduct.text.find((item) => item.textType === 0)?.text ||
    "";

  const productImage = productImages.filter(
    (image) => image.ecItemRefRecID.toString() === supercede.sourceProduct.id
  );

  let displayLowerOriginalPrice = SupercedeDisplayCondition.Always;
  const selectedItemSellPrice = supercede.sourceProduct.sellPrice;
  const firstSupercedeItemPrice = supercede.relatedProducts[0].sellPrice;

  if (
    supercede.displayLowerOriginalPrice === SupercedeDisplayCondition.Never &&
    selectedItemSellPrice < firstSupercedeItemPrice
  ) {
    displayLowerOriginalPrice = SupercedeDisplayCondition.Never;
  }

  const cartTrans: ISupersedeCartItem = {
    qty: 1,
    isMobile: false,
    altText: "",
    itemIndicators,
    itemId: supercede.sourceProduct.itemId,
    smallText: false,
    isCartItemDropdown: false,
    cartItemDropdownProps: {},
    discount: 1,
    unitId: supercede.sourceProduct.unitId,
    brandName: supercede.sourceProduct.brandName,
    description,
    unitPrice: selectedItemSellPrice,
    listPrice: supercede.sourceProduct.listPrice,
    imgUrl: productImage.length
      ? `${productImage[0].imagePath}/${productImage[0].imageFileName}`
      : "",
    itemIdentifier: {
      id: supercede.sourceProduct.itemId,
      unitId: supercede.sourceProduct.unitId,
      couponOfferCode: "",
    },
    availabilityInfo: availabilityInfo,
    sellPrice: supercede.sourceProduct.sellPrice,
    displayLowerOriginalPrice,
    supercedePopup: true,
    hostUrl
  };
  return cartTrans;
}
